import React from "react";
import { styled } from "../../stitches.config";
import { withThemeContext } from "./StitchesThemeProvider";

import Youtube from "../../components/Article/Parts/Youtube";
import OnnetworkPlayer from "../../components/OnnetworkPlayer";
import TiktokEmbed from "../../components/Article/Content/body/TiktokEmbed";

interface EmbedProps {
  article?: any,
}

const EmbedCarousel: React.FC<EmbedProps> = ({
  article,
}) => {

  // const url = article.url;
  const embed = article.embed;
  const tiktokProfileId = "@natemat.pl";
  const tiktokVideoId = "7340668845377555744?is_from_webapp=1&web_id=7150995076611655173";

  // console.log("embed test: ", embed)
  return (
    <StyledEmbed>

      {embed?.type === "tiktok" &&
        <EmbedWrapper type="tiktok">
          <TiktokEmbed profile={embed.profile} noWrapper={true} videoId={embed.videoId} />
        </EmbedWrapper>
      }

      {embed?.type === "onnetwork" && 

          <EmbedWrapper type="onnetwork">
            <EmbedElement>
              <OnnetworkPlayer
                mid={embed.mid}
              />
            </EmbedElement>
           </EmbedWrapper>
      }

      {embed?.type === "youtube" &&
        <EmbedWrapper type="youtube">
          <EmbedElement>
            <Youtube isOneSuper={false} videoId={embed.id} />
          </EmbedElement>
        </EmbedWrapper>
      }

      {/* url && <UniversalEmbedBox article={article} /> */}
    </StyledEmbed>
  );
};

const StyledEmbed = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto",
});


const EmbedWrapper = styled("div", {
  width: "200px",

  variants: {
    type: {
      youtube: {
        height: "130px",
        width: "270px",
        margin: "0 16px 0 0",
        "@media(min-width: 400px)": {
          width: "290px",
          height: "150px",
        },
        "@media(min-width: 440px)": {
          width: "320px",
          height: "180px",
        },
        "@media(min-width: 840px)": {
          width: "340px",
        },
        "@bp4": {
          margin: "0",
          height: "200px",
          width: "300px",
        },
      },
      onnetwork: {
        height: "130px",
        width: "270px",
        margin: "0 16px 0 0",
        "@media(min-width: 400px)": {
          width: "290px",
          height: "150px",
        },
        "@media(min-width: 440px)": {
          width: "320px",
          height: "180px",
        },
        "@media(min-width: 840px)": {
          width: "340px",
        },
        "@bp4": {
          margin: "0",
          height: "200px",
          width: "300px",
        },
      },
      tiktok: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        height: "540px",
        width: "330px",
        scale: "75%",
        margin: "0 16px 0 0",
        "@media(min-width: 390px)": {
          scale: "85%",
          height: "600px",
        },
        "@media(min-width: 410px)": {
          scale: "90%",
          height: "650px",
        },
        "@media(min-width: 475px)": {
          height: "700px",
          scale: "95%",
        },
        "@bp4": {
          margin: "0",
          width: "330px",
          scale: "90%",
        },
        "@bp5": {
          scale: "115%",
          height: "880px",
          width: "344px",
        }
      }
    }
  }

});

const EmbedElement = styled("span", {
  display: "block",
  position: "static",
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,

  "& .part--youtube-video": {
    margin: 0,
    paddingTop: 0,
    paddingBottom: "54%",
    backgroundColor: "black",
  },

  "& .onnetwork-video": {
    margin: 0,
    paddingTop: 0,
    paddingBottom: "54%",
    backgroundColor: "black",
  },

  "@bp4": {
    position: "static",
    backgroundColor: "black",

    "& .part--youtube-video": {
      height: "200px",
    },
    "& .onnetwork-video": {
      height: "200px",
    }
  }

});


export default withThemeContext(EmbedCarousel);
